import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export default function PaymentIcon(props: SvgIconProps): JSX.Element {
    const defaultColor = "primary";
    const color = props.color || defaultColor;
    return (
        <SvgIcon
            {...props}
            color={color}
            xmlns="http://www.w3.org/2000/svg"
            x={0}
            y={0}
            viewBox="0 0 24 24"
            xmlSpace="preserve"
            enableBackground="new 0 0 24 24"
            titleAccess="Payment" fill="none">
            <path
                fillRule="evenodd"
                d="M8.681 22.053c2.1.625 4.341.594 6.423-.09a.75.75 0 0 0 .479-.946l-.023-.07a.75.75 0 0 0-.946-.478 9.176 9.176 0 1 1 6.173-10.318.75.75 0 0 0 .87.608l.07-.013a.75.75 0 0 0 .609-.869A10.75 10.75 0 1 0 8.68 22.053Zm3.892-16.73a.75.75 0 1 0-1.5 0v.789c-.638.066-1.324.227-1.923.553-.89.486-1.578 1.344-1.578 2.659 0 1.315.687 2.172 1.578 2.658.599.327 1.285.488 1.923.554v3.484a3.465 3.465 0 0 1-.884-.256c-.455-.203-.881-.515-1.337-.97a.75.75 0 1 0-1.06 1.06c.544.544 1.118.983 1.788 1.28.465.207.957.338 1.493.399v.79a.75.75 0 1 0 1.5 0v-.792c.645-.074 1.332-.251 1.928-.586.875-.49 1.57-1.34 1.57-2.621 0-1.28-.695-2.13-1.57-2.621-.596-.335-1.283-.512-1.928-.586V7.625c.893.126 1.452.463 1.719.73a.75.75 0 1 0 1.06-1.061c-.56-.561-1.503-1.043-2.779-1.18v-.79Zm-1.5 2.3c-.44.058-.864.173-1.204.36-.484.263-.797.655-.797 1.34 0 .686.313 1.078.797 1.342.34.186.763.302 1.204.36V7.622Zm1.5 5.007v3.388c.434-.065.854-.19 1.194-.38.501-.282.805-.682.805-1.314 0-.633-.304-1.032-.805-1.313-.34-.192-.76-.316-1.194-.381Zm8.18.24a.2.2 0 0 0-.363-.114l-3.535 5.011a.3.3 0 0 0 .245.473h1.652v4.418a.2.2 0 0 0 .357.123l3.544-4.556a.3.3 0 0 0-.236-.484h-1.664v-4.87Z"
                clipRule="evenodd"
            />
        </SvgIcon>
    );
}
